function formatPercentage(percent) {
    return percent.toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 });
}
export { formatPercentage };
